// extracted by mini-css-extract-plugin
export default {"header":"PublishDisclosure_header__UcYCq"};